import { Injectable } from '@angular/core';
import {environment} from "../../../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {SubmitEmploymentDetailsReq} from "../Models/Requests/SubmitEmploymentDetailsReq";
import {Observable} from "rxjs";
import {Employers} from "../../../../Shared/Models/Employers";
import {BeneficiaryEmploymentDetails} from "../../../../Shared/Models/BeneficiaryEmploymentDetails";
import {OlamsLUGStatementResponse} from "../Models/Responses/OlamsLUGStatementResponse";
import {LoaneeBills} from "../Models/LoaneeBills";
import {GenLoaneeBillRequest} from "../Models/Requests/GenLoaneeBillRequest";
import {SubmitBenefAdvancedSearchReq} from "../../../../../account/auth/Models/Requests/SubmitBenefAdvancedSearchReq";
import {BenefAdvancedSearchModel} from "../../../../../account/auth/Models/BenefAdvancedSearchModel";
import {Institutions} from "../Models/Institutions";

@Injectable({
  providedIn: 'root'
})
export class LipaService {
  public lipa_service_url: string = environment.lipa_service_url;
  constructor(private http: HttpClient) { }

  public saveEmploymentDetails(req: SubmitEmploymentDetailsReq): Observable<BeneficiaryEmploymentDetails> {
    return this.http.post<BeneficiaryEmploymentDetails>(`${this.lipa_service_url}/loan-details/employment-details/`, req);
  }
  public updateEmploymentDetails(req: SubmitEmploymentDetailsReq): Observable<BeneficiaryEmploymentDetails> {
    return this.http.patch<BeneficiaryEmploymentDetails>(`${this.lipa_service_url}/loan-details/employment-details/`, req);
  }

  public getBenefEmploymentDetails(): Observable<BeneficiaryEmploymentDetails> {
    return this.http.get<BeneficiaryEmploymentDetails>(`${this.lipa_service_url}/loan-details/employment-details/`);
  }

  public getPrivateEmployers(): Observable<Employers[]> {
    return this.http.get<Employers[]>(`${this.lipa_service_url}/shared-app-lipa/get-private-employers/`)
  }

  public getPublicEmployers(): Observable<Employers[]> {
    return this.http.get<Employers[]>(`${this.lipa_service_url}/shared-app-lipa/get-public-employers/`)
  }

  public getAllInstitutions(): Observable<Institutions[]> {
    return this.http.get<Institutions[]>(`${this.lipa_service_url}/shared-app-lipa/get-all-institutions/`)
  }

  public getLUGLoaneeStatement(index_no: string): Observable<OlamsLUGStatementResponse> {
    const params: HttpParams = new HttpParams().set('index_no', index_no);
    return this.http.get<OlamsLUGStatementResponse>(`${this.lipa_service_url}/loan-details/lug-loan-statement/`, {params});
  }

  public getLonaeeGeneratedBills(index_no: string): Observable<LoaneeBills[]> {
    const params: HttpParams = new HttpParams().set('index_no', index_no);
    return this.http.get<LoaneeBills[]>(`${this.lipa_service_url}/payment/loanee-bills/`, {params});
  }

  public generateLoaneeBill(req: GenLoaneeBillRequest): Observable<LoaneeBills> {
    return this.http.post<LoaneeBills>(`${this.lipa_service_url}/payment/loanee-bills/`, req);
  }

  submitBenefAdvancedSearchDetails(req: SubmitBenefAdvancedSearchReq): Observable<BenefAdvancedSearchModel> {
    return this.http.post<BenefAdvancedSearchModel>(`${this.lipa_service_url}/loan-details/register-benef-advanced-search/`, req);
  }
  getBenefAdvancedSearchProgress(referenceNumber: string): Observable<BenefAdvancedSearchModel> {
    const params: HttpParams = new HttpParams().set('reference_number', referenceNumber);
    return this.http.get<BenefAdvancedSearchModel>(`${this.lipa_service_url}/loan-details/register-benef-advanced-search/`, {params});
  }


}
